import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { UsuarioService } from '../../services/Usuario.service';
import { NacionalidadService } from '../../services/nacionalidad.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SociedadService } from 'src/app/services/sociedades.service';


class Codigo {
  codigoPostal: number;
  colonia: string[] = [];
  municipio: string[] = [];
  estado: string[] = [];
  numeroInterior: string;
  numeroExterior: string;
  calle: string;
  coloniaSeleccion: string;
  municipioSeleccion: string;
  estadoSeleccion: string;
}

class Mail {
  destinatario: string;
  cuerpo: string;
  asunto: string;
}

class Usuario {
  rfcUsuario: string;
  nombre: string;
  contrasena: string;
  contrasenaConfirmacion: string;
  direccion: string;
  correo: string;
  nacionalidad: string;
  tiempoSesion: number;
  phone: string;
  active: boolean;
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html'
})

export class RegisterComponent {

  //CREACION DE VARIABLES
  usuario: Usuario = {
    rfcUsuario: null,
    nombre: null,
    contrasena: null,
    contrasenaConfirmacion: null,
    correo: null,
    direccion: null,
    nacionalidad : null,
    tiempoSesion: 30,
    phone: null,
    active: true
  };
  recoverform = false;
  registroForm = true;
  messageAlert: string;
  typeAlert: string;
  nacionalidades: string[];
  codigo: Codigo;
  // Ventana Modal
  modal: any;
  datosDomicilio = false;
  terms_accept = false;
  privacy_accept = false;
  showPassword = false;
  showConfirmPassword = false;

  constructor(private toastr: ToastrService,
    private spinner: NgxSpinnerService, private modalService: NgbModal,
    private nacionalidadService: NacionalidadService, private sociedadService: SociedadService,
    private usuarioService: UsuarioService,
    private router: Router) {
    this.listaNacionalidades();
    this.codigo = new Codigo();
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  showMessageAlert(tipo: string, mensaje: string) {
    this.messageAlert = mensaje;
    this.typeAlert = tipo;
    setTimeout(() => this.messageAlert = null, 5000);
  }


  validaRfc( rfc ) {
    if (rfc.length === 12) {
      let cadena = /[A-Z]+[A-Z]+[A-Z]+\d+\d+\d+\d+\d+\d+([A-Z]|\d)+([A-Z]|\d)+([A-Z]|\d)/;
      return cadena.test(rfc) ? true : false;
    } else {
      let cadena = /[A-Z]+[A-Z]+[A-Z]+[A-Z]+\d+\d+\d+\d+\d+\d+([A-Z]|\d)+([A-Z]|\d)+([A-Z]|\d)/;
      return cadena.test(rfc) ? true : false;
    }
}

validaEmail( email ) {
  let regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email) ? true : false;
}


registro(registroForm: NgForm) {
  this.usuario.rfcUsuario = this.usuario.rfcUsuario.toUpperCase();
 this.usuario.nombre = this.titleCase(this.usuario.nombre);
  if (this.validaRfc(this.usuario.rfcUsuario)) {
      if (this.validaEmail(this.usuario.correo)) {
        if (this.usuario.contrasena === this.usuario.contrasenaConfirmacion) {
          console.log('aqui se queda');
          this.spinner.show();
          this.usuarioService.find(this.usuario.rfcUsuario).subscribe(
            message => {
              if (message['httpStatus'] === 200) {
                if (!message['usuarioModel']) {
                  this.altaUsuario();
                } else {
                  this.showMessage('warning', 'RFC Repetido', 'El RFC ya ha sido introducido');
                  this.spinner.hide();
                }
              } else if (message['httpStatus'] === 400) {
                this.showMessage('error', message['message'], message['messageDetail']);
                this.showMessageAlert('danger', message['messageDetail']);
              }
            },
            error => {
              if (error.status === 0) {
                this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los usuarios');
                this.showMessageAlert('danger', 'No existe conexión para obtener los usuarios');
              } else if (error.status === 403) {
              }
            },
            () => {
              this.spinner.hide();
            }
          );
        } else {
          this.showMessage('warning', 'Contraseña Invalida', 'No ha ingresado la misma contraseña');
        }
      } else {
        this.showMessage('warning', 'Correo Electronico', 'Correo Electronico invalido');
      }
  } else {
    this.showMessage('warning', 'RFC Invalido', 'Introduzca RFC Valido');
  }
}

altaUsuario() {
  let usuario = {
    rfc: this.usuario.rfcUsuario,
    direccion: this.usuario.direccion,
    correo: this.usuario.correo,
    nombre: this.usuario.nombre,
    password: this.usuario.contrasena,
    nacionalidad: this.usuario.nacionalidad,
    tiempoSesion: 30,
    phone: this.usuario.phone,
    active: true
    
  };
  this.usuarioService.add(usuario).subscribe(
    message => {
      if (message['httpStatus'] === 200) {
        this.showMessage('info', message['message'], message['messageDetail']);
        this.showMessageAlert('info', message['messageDetail']);
        this.spinner.hide();
        this.envioMail();
        this.router.navigate(['']);
      } else if (message['httpStatus'] === 400) {
        this.showMessage('error', message['message'], message['messageDetail']);
        this.showMessageAlert('danger', message['messageDetail']);
        this.spinner.hide();
      }
    },
    error => {
      this.spinner.hide();
      if (error.status === 0) {
        this.showMessage('error', 'Error de conexión', 'No existe conexión para agregar el usuario');
        this.showMessageAlert('danger', 'No existe conexión para agregar el usuario');
      } else if (error.status === 403) {
        this.goLogin();
      }
    },
    () => {
    }
  );
}

  envioMail() {
    /*let mail: Mail = {
      destinatario: this.usuario.correo,
      asunto: 'Registro De Cuenta Exitoso',
      cuerpo: 'Gracias por registrarte en nuestro portal de gestion de sociedades propiedad de TRACER México, las credenciales' +
      ' para poder ingresar a la aplicacion son las siguientes: URL:http://localhost:4200/#/ USUARIO: ' + this.usuario.rfcUsuario +
      ' contraseña: ' + this.usuario.contrasena + '/n  Gracias por su preferencia.'
    };*/
    let mail: Mail = {
      destinatario: this.usuario.correo,
      asunto: 'Registro De Cuenta Exitoso',
      cuerpo: '<h3>Gracias por registrarte en nuestro portal de gestión de sociedades propiedad de Tu Vida Digital</h3>' +
      '<p>Para poder ingresar a la aplicación ingrese los datos siguientes</p>' +
      //'<p>URL del sitio <a href="http://localhost:4200/#/login/registro">Tracer Mexico</a></p>' +
      '<p>URL del sitio <a href="https://app.tuvida.digital/#/login/registro">Tu Vida Digital</a></p>' +
      '<p><b>USUARIO:</b> ' +  this.usuario.rfcUsuario + ' </p>' +
      '<p><b>CONTRASEÑA:</b> ' +   this.usuario.contrasena + ' </p>'
    };
    this.usuarioService.enviomail(mail).subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          this.showMessage('info', message['message'], message['messageDetail']);
          this.showMessageAlert('info', message['messageDetail']);
        } else if (message['httpStatus'] === 400) {
          this.showMessage('error', message['message'], message['messageDetail']);
          this.showMessageAlert('danger', message['messageDetail']);
        }
      },
      error => {
        this.spinner.hide();
        if (error.status === 0) {
          console.log('no hay conexion');
          this.showMessage('error', 'Error de conexión', 'No existe conexión para enviar el email al usuario');
          this.showMessageAlert('danger', 'No existe conexión para enviar el mail al usuario');
        } else if (error.status === 403) {
          this.goLogin();
        }
      },
      () => {
      }
    );
  }

  goLogin() {
    localStorage.clear();
    this.router.navigate(['']);
  }

  showRecoverForm() {
    this.registroForm = !this.registroForm;
    this.recoverform = !this.recoverform;
  }


//IMPLEMENTACION DE LA FUNCION PAR ALOS NOMBRES
//Leva a mayúsculas la primera letra de cada palabra
 titleCase(texto) {
  const re = /(^|[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ])(?:([a-záéíóúüñ])|([A-ZÁÉÍÓÚÜÑ]))|([A-ZÁÉÍÓÚÜÑ]+)/gu;
  return texto.replace(re,
      (m, caracterPrevio, minuscInicial, mayuscInicial, mayuscIntermedias) => {
          const locale = ['es', 'gl', 'ca', 'pt', 'en'];
          //Son letras mayúsculas en el medio de la palabra
          // => llevar a minúsculas.
          if (mayuscIntermedias) {
              return mayuscIntermedias.toLocaleLowerCase(locale);
          }
          //Es la letra inicial de la palabra
          // => dejar el caracter previo como está.
          // => si la primera letra es minúscula, capitalizar
          //    sino, dejar como está.
          return caracterPrevio
               + (minuscInicial ? minuscInicial.toLocaleUpperCase(locale) : mayuscInicial);
      }
  );
  }

  listaNacionalidades() {
    console.log('NACIONALIDADES');
      this.nacionalidadService.getAll().subscribe(
        message => {
          console.log('ENTRO');
          if (message['httpStatus'] === 200) {
            this.spinner.show();
            let naciones: string[] = [];
            console.log('HOLA');
            for (let i = 0; i < message['nacionalidades'].length; i++) {
              naciones.push(this.titleCase(message['nacionalidades'][i].genticilio));
            }
            this.nacionalidades = naciones.slice();
          } else if (message['httpStatus'] === 400) {
            this.showMessage('error', message['message'], message['messageDetail']);
            this.showMessageAlert('danger', message['messageDetail']);
          }
        },
        error => {
          if (error.status === 0) {
            this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener las naciones');
            this.showMessageAlert('danger', 'No existe conexión para obtener las naciones');
          } else if (error.status === 403) {
            this.goLogin();
          }
        },
        () => {
          console.log(this.nacionalidades);
          this.spinner.hide();
        }
      );
  }

    ////////Para abrir una ventana modal
    openVerticallyCentered(content) {
      this.modal = this.modalService.open(content, { centered: true });
    }

    crearDomicilioSociedad() {
        if (this.codigo.calle.length > 0 && this.codigo.numeroExterior.length > 0) {
          if (this.codigo.numeroInterior.length > 0) {
            let domicilio: string = this.titleCase(this.codigo.calle) + ' ' + this.codigo.numeroExterior + ' Int. ' + this.codigo.numeroInterior +
            ', Colonia ' + this.codigo.coloniaSeleccion + ', ' + this.codigo.municipioSeleccion + ', '
            + this.codigo.estadoSeleccion + ', Codigo postal ' + this.codigo.codigoPostal;
           console.log(domicilio);
           this.usuario.direccion = domicilio;
          } else {
            let domicilio: string = this.titleCase(this.codigo.calle) + ' ' + this.codigo.numeroExterior + ', Colonia ' + this.codigo.coloniaSeleccion + ', ' + this.codigo.municipioSeleccion + ', '
            + this.codigo.estadoSeleccion + ', Codigo postal ' + this.codigo.codigoPostal;
           console.log(domicilio);
           this.usuario.direccion = domicilio;
          }
          this.datosDomicilio = false;
          this.modal.dismiss();
        } else {
          this.showMessage('error', 'Calle y Numero Invalido', 'La calle y el numero son necesarios');
        }
    }

    closeModal() {
      this.modal.dismiss();
    }

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }

    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    }

    metodoModal() {
      console.log('metodo crear domicilio');
      if (this.codigo.codigoPostal === undefined) {
        this.showMessage('error', 'Código Postal Invalido', 'El código postal no existe');
      } else {
          console.log('entro a la opcion 1');
          this.sociedadService.codigoPostal(this.codigo.codigoPostal).subscribe(
            message => {
              if (message['httpStatus'] === 200) {
                if ( message['codigosPostales'].length > 0) {
                this.codigo.colonia = [];
                this.codigo.municipio = [];
                this.codigo.estado = [];
                let colonia: string[] = [];
                let municipio: string[] = [];
                let estado: string[] = [];
                  for (let i = 0; i < message['codigosPostales'].length; i++) {
                    console.log('ciclo');
                    console.log(this.codigo.codigoPostal);
                    if (i < 1) {
                      this.codigo.coloniaSeleccion = message['codigosPostales'][i].colonia;
                      this.codigo.municipioSeleccion = message['codigosPostales'][i].municipio;
                      this.codigo.estadoSeleccion = message['codigosPostales'][i].estado;
                      this.codigo.numeroExterior = '';
                      this.codigo.numeroInterior = '';
                      this.codigo.calle = '';
                      colonia.push(message['codigosPostales'][i].colonia);
                      municipio.push(message['codigosPostales'][i].municipio);
                      estado.push(message['codigosPostales'][i].estado);
                    } else {
                      if (colonia.indexOf(message['codigosPostales'][i].colonia) < 0) {
                        colonia.push(message['codigosPostales'][i].colonia);
                      }
                      if (municipio.indexOf(message['codigosPostales'][i].municipio) < 0) {
                        municipio.push(message['codigosPostales'][i].municipio);
                      }
                      if (estado.indexOf(message['codigosPostales'][i].estado) < 0) {
                        estado.push(message['codigosPostales'][i].estado);
                      }
                    }
                  }
                  this.codigo.colonia = colonia.slice();
                  this.codigo.municipio = municipio.slice();
                  this.codigo.estado = estado.slice();
                  this.datosDomicilio = true;
                } else {
                  this.showMessage('error', 'Código Postal Invalido', 'El código postal no existe');
                  this.datosDomicilio = false;
                }
              } else if (message['httpStatus'] === 400) {
                this.showMessage('error', message['message'], message['messageDetail']);
                this.showMessageAlert('danger', message['messageDetail']);
              }
            },
            error => {
              if (error.status === 0) {
                this.showMessage('error', 'Error de conexión', 'No existe conexión para agregar la Version');
                this.showMessageAlert('danger', 'No existe conexión para agregar la Version');
              } else if (error.status === 403) {
                this.goLogin();
              }
            },
            () => {
            }
          );
          console.log(this.codigo);
      }
    }

}
